import { Outlet } from 'react-router'
import { SettingsSidebar } from '../components/sidebar'
import { usePageTitle } from '$components'

export function SettingsPage() {
  usePageTitle('Settings')

  return (
    <div className="w-full flex flex-row h-full overflow-hidden">
      <SettingsSidebar />

      <div className="flex-grow overflow-y-auto p-4">
        <Outlet />
      </div>
    </div>
  )
}
